import { usePage } from '@inertiajs/vue3'
import { eventBus } from '@/Mixins/eventbus.js'

/**
 * A View As session cannot request edits or revisions. The server refuses them
 * (ViewAsEditRequestBlockedException); these helpers let the UI say so before
 * the customer's form is even opened, and turn a server refusal from any other
 * path into the same dialog.
 *
 * Only an MS admin can start View As, so the dialog only ever reaches them.
 */
export const VIEW_AS_BLOCKED_EVENT = 'view-as-edit-request-blocked'

/** Mirrors ViewAsEditRequestBlockedException::TYPE. */
const VIEW_AS_BLOCKED_TYPE = 'view_as_edit_request_blocked'

export function isViewAsSession(): boolean {
    try {
        return usePage().props.isImpersonating === true
    } catch {
        return false
    }
}

export function showViewAsBlocked(): void {
    eventBus.emit(VIEW_AS_BLOCKED_EVENT)
}

/** True (and the dialog shown) when the current session is View As. */
export function blockIfViewAs(): boolean {
    if (!isViewAsSession()) return false
    showViewAsBlocked()
    return true
}

interface BlockedErrorShape {
    response?: { status?: number; data?: { type?: string } }
}

export function isViewAsBlockedError(error: unknown): boolean {
    const response = (error as BlockedErrorShape | null)?.response
    return response?.status === 403 && response?.data?.type === VIEW_AS_BLOCKED_TYPE
}
